import { createAction, props } from '@ngrx/store';

export const enum ApoActionTypes {
  addApoFeatures = '[apo] ADD_APO_FEATURES',
  saveApoFeatures = '[apo] SAVE_APO_FEATURES',
}

export const addApoFeatures = createAction(
  ApoActionTypes.addApoFeatures,
  props<{ features: Record<string,string> }>(),
);

export const saveApoFeatures = createAction(ApoActionTypes.saveApoFeatures);
